var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout-nav"},[_c('div',{staticClass:"nav-bar-main app-nav-bar"},_vm._l((_vm.navs),function(item,idx){return _c('div',{key:idx,staticClass:"nav-bar-link",on:{"click":function($event){return _vm.navClick(item)}}},[_c('div',{staticClass:"nav-item-main",class:{
          'nav-item-active': item.path == _vm.$route.fullPath,
        }},[_c('div',[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"nav-item-subtitle"},[_vm._v(_vm._s(item.desc))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }